export default __webpack_public_path__ + "69368bcf4b491c9f2383d6905c64e7fe.png";